import { render, staticRenderFns } from "./NavbarNavIcon.vue?vue&type=template&id=0090b6e3&scoped=true&"
import script from "./NavbarNavIcon.vue?vue&type=script&lang=js&"
export * from "./NavbarNavIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavbarNavIcon.vue?vue&type=style&index=0&id=0090b6e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0090b6e3",
  null
  
)

export default component.exports